export default {
  organizationBrandAlt: {
    pt: 'Marca do organizador',
    en: 'Organizer brand',
    es: 'Marca del organizador',
  },
  eventBrandAlt: {
    pt: 'Marca do evento',
    en: 'Event brand',
    es: 'Marca de evento',
  },
  mastercard: {
    pt: 'Mastercard',
    en: 'Mastercard',
    es: 'Mastercard',
  },
  visa: {
    pt: 'Visa',
    en: 'Visa',
    es: 'Visa',
  },
  'american-express': {
    pt: 'American Express',
    en: 'American Express',
    es: 'American Express',
  },
  elo: {
    pt: 'Elo',
    en: 'Elo',
    es: 'Elo',
  },
  'diners-club': {
    pt: 'Diners Club',
    en: 'Diners Club',
    es: 'Diners Club',
  },
  discover: {
    pt: 'Discover',
    en: 'Discover',
    es: 'Discover',
  },
};



// WEBPACK FOOTER //
// ./src/intl/messages/imageAlt.js